(() => {
  const css = `
    .cart__clear-btn {
      display: flex; align-items: center; justify-content: space-between;
      width: 100%; padding: 13px 15px; margin: 0; box-sizing: border-box;
      background: transparent; border: 0; border-top: 1px solid rgb(243, 243, 243);
      cursor: pointer; font-family: inherit; font-size: 12px; font-weight: 700;
      color: inherit; text-align: left; letter-spacing: inherit;
      text-transform: none; line-height: 1;
    }
    .cart__clear-btn::after { content: '×'; font-size: 18px; font-weight: 400; line-height: 1; opacity: .5; }
    .cart__clear-btn:hover { background: rgba(0,0,0,.03); }
    .cart__clear-btn:disabled { opacity: .5; cursor: wait; }
    .drawer--cart.is-empty .cart__clear-btn,
    .cart--is-empty .cart__clear-btn { display: none; }
  `
  const style = document.createElement('style')
  style.textContent = css
  document.head.appendChild(style)

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-clear]')
    if (!btn) return
    e.preventDefault()
    if (!confirm('Deseja remover todos os itens do carrinho?')) return
    const originalText = btn.textContent
    btn.disabled = true
    btn.textContent = 'Limpando...'
    try {
      const res = await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      if (!res.ok) throw new Error('Erro ao limpar carrinho')
      window.location.reload()
    } catch (err) {
      alert(err.message || 'Erro ao limpar carrinho.')
      btn.disabled = false
      btn.textContent = originalText
    }
  })
})()
